import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { useAppSelector } from 'store/hooks';
import {
  selectBreakoutRoomBackToMainRoom,
  selectBreakoutRoomFreeMovement,
  selectBreakoutRoomsCreated,
  selectBreakoutRoomsStatus,
} from 'features/breakout-rooms/breakoutRoomsSlice';

export const useBreakoutRooms = () => {
  const { hasPermissions } = usePermissions();
  const canManageBreakout = hasPermissions(PermissionTypes.manageBreakout);

  const status = useAppSelector(selectBreakoutRoomsStatus);
  const freeMovement = useAppSelector(selectBreakoutRoomFreeMovement);
  const backToMainRoom = useAppSelector(selectBreakoutRoomBackToMainRoom);

  const breakoutRoomsCreated = useAppSelector(selectBreakoutRoomsCreated);

  const isBreakoutsAvailable = useFeatureFlag('breakoutRooms');
  const hasBreakoutManagementAccess = isBreakoutsAvailable && canManageBreakout;

  const breakoutsFreeMovementAvailable =
    isBreakoutsAvailable && status === 'started' && freeMovement;

  const breakoutsFreeMovementOnlyAvailable =
    !hasBreakoutManagementAccess && breakoutsFreeMovementAvailable;

  const breakoutsBackToMainRoomAvailable =
    isBreakoutsAvailable && status === 'started' && backToMainRoom;

  return {
    hasBreakoutManagementAccess,
    breakoutRoomsCreated,
    canManageBreakout,
    status,
    breakoutsFreeMovementAvailable,
    breakoutsFreeMovementOnlyAvailable,
    breakoutsBackToMainRoomAvailable,
  };
};
